import React from "react";
import { connect } from "react-redux";
import { Card, Button, Modal, Tooltip } from "antd";
import PropTypes from "prop-types";
import Chip from "components/common/Chip";
import MaterialIcon from "components/common/MaterialIcon";
import Avatar from "components/common/Avatar";
import Spin from "components/common/Spin";
import FChart from "routes/Home/Basic/OrganizationChart/FChart";
import ApplicantsTree from "./ApplicantsTree";
import {
  indexPositions,
  emptyPositions,
} from "routes/Home/Basic/OrganizationChart/Module";

@connect(
  (state) => ({
    positions: state.Basic.OrganizationChart.positions,
  }),
  {
    indexPositions,
    emptyPositions,
  },
  null,
  { withRef: true }
)
@autobind
/**
 *
 */
export default class Positions extends React.PureComponent {
  static propTypes = {
    positions: PropTypes.arrayOf(PropTypes.object),
    indexPositions: PropTypes.func,
    emptyPositions: PropTypes.func,
    selected: PropTypes.array,
    title: PropTypes.any,
    componentName: PropTypes.string,
    onChange: PropTypes.func,
  };

  static defaultProps = {
    selected: [],
    componentName: "Chart",
    onChange: () => {},
  };

  /**
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props);

    this.state = {
      spinning: false,
      showAddForm: false,
      selected: props.selected,
    };
  }

  /**
   *
   */
  componentDidMount() {
    const { indexPositions, componentName, positions, positionValue } =
      this.props;
    const { selected } = this.state;
    if (positionValue) {
      const positionItems = positionValue.map((item) => item.id);
      this.setState({
        selected: [...selected, ...positionItems],
      });
    }

    if (!positions || app._.isEmpty(positions)) {
      this.setState({ spinning: true }, () => {
        indexPositions(componentName, () => {
          this.setState({ spinning: false });
        });
      });
    } else {
      this.setState({ spinning: false });
    }
  }
  componentDidUpdate() {
    if (!!this.props?.getSelected) {
      this.props?.getSelected(this.state?.selected);
    }
  }
  /**
   *
   * @param {Object} np
   */
  componentWillReceiveProps(np) {
    if (!app._.isEqual(this.props.selected, np.selected)) {
      this.setState({ selected: np.selected });
    }
  }

  /**
   *
   */
  componentWillUnmount() {
    super.componentWillUnmount();

    app.dispatch(emptyPositions());
  }
  /**
   *
   * @return {Number[]}
   */
  selected() {
    const { selected } = this.state;
    // Make sure we return selected as an array of numbers
    return Array.isArray(selected) ? 
      selected.map(id => typeof id === 'string' ? parseInt(id) : id) : 
      [];
  }

  /**
   *
   * @private
   */
  _onAdd = () => {
    const selected = app._.cloneDeep(this.positionsChart.selected());
    // if (this.props.positionValue) {
    // selected.push(33);
    // }
    // selected = selected.map((item) => item * 1);
    this.setState({
      selected,
      showAddForm: false,
    });
    this.props.onChange(selected);
  };

  /**
   *
   * @param {Number} id
   * @private
   */
  _onDelete(id) {
    const selected = app._.cloneDeep(this.state.selected);
    let _index = selected.findIndex((item) => parseInt(item) == parseInt(id));
    if (_index > -1) {
      selected.splice(_index, 1);

      this.setState({ selected });

      this.props.onChange(selected);
    }
  }

  /**
   *
   * @return {Node[]}
   * @private
   */
  get _chips() {
    const { selected } = this.state;
    const { positions, positionValue } = this.props;

    let _chips = [];

    if (positions) {
      positions.map((position) => {
        if (
          selected.findIndex(
            (item) => parseInt(item) == parseInt(position.id)
          ) > -1
        ) {
          let _chip = (
            <Chip key={position.id}>
              <Avatar src={position.avatar} text={position.name} />

              {position.name}

              <MaterialIcon
                name="close-circle"
                onClick={() => this._onDelete(position.id)}
              />
            </Chip>
          );

          if (position.user && position.user.profile) {
            _chip = (
              <Tooltip
                key={position.id}
                title={`${position.user.profile.firstName} ${position.user.profile.lastName}`}
              >
                {_chip}
              </Tooltip>
            );
          }

          _chips.push(_chip);
        }
      });
    }

    if (_chips.length == 0) {
      _chips.push(
        <div
          key={0}
          style={{
            width: "100%",
            textAlign: "center",
          }}
        >
          {app.translate("main.No data")}
        </div>
      );
    }

    return _chips;
  }

  /**
   *
   * @return {XML}
   */
  render() {
    const { selected, showAddForm, spinning } = this.state;
    const { title, positions, errorDescription } = this.props;
    let state = Object.assign(
      {},
      {
        backgroundColor: { hex: "#404040" },
        organizationChart: "chart",
      },
      app.local.load("app")
    );

    return (
      <Spin spinning={spinning}>
        {state.organizationChart == "tree" ? (
          <Card
            title={
              title ||
              app.translate("routes.home.requests.procedure.Applicants")
            }
            style={{ height: "100%" }}
          >
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
              }}
            >
              <ApplicantsTree
                ref={(input) =>
                  (this.positionsChart = input && input?.getWrappedInstance())
                }
                selected={selected}
                items={positions}
                onChange={(selected) => {
                  // Update the selected state in this component
                  this.setState({ selected });
                  // Pass the selected values to the parent component
                  this.props.onChange(selected);
                }}
              />
            </div>
          </Card>
        ) : (
          <Card
            title={
              title ||
              app.translate("routes.home.requests.procedure.Applicants")
            }
            extra={
              <Button
                type="primary"
                icon="plus"
                onClick={() => this.setState({ showAddForm: true })}
              >
                {app.translate("main.Add")}
              </Button>
            }
            style={{
              height: "100%",
              border: errorDescription ? "2px solid red" : null,
            }}
          >
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
              }}
            >
              {this._chips}
            </div>

            {showAddForm && (
              <Modal
                title={title || app.translate("routes.Requests")}
                visible={showAddForm}
                onOk={this._onAdd}
                onCancel={() => this.setState({ showAddForm: false })}
                width="100%"
                style={{
                  height: "100%",
                }}
              >
                <FChart
                  ref={(input) =>
                    (this.positionsChart = input && input?.getWrappedInstance())
                  }
                  selected={selected}
                  items={positions}
                />
              </Modal>
            )}
          </Card>
        )}
      </Spin>
    );
  }
}
